import { createSlice } from "@reduxjs/toolkit";

const initialStates = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    debtOrderEntities: [],
    debtTotal: 0,
    debtOrderForEdit: undefined,
    lastError: null,
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const DebtOrderSlice = createSlice({
    name: "debtOrder",
    initialState: initialStates,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        debtOrderListFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.debtOrderEntities = action.payload.debtOrderEntities;
            state.debtTotal = action.payload.debtTotal;
            state.totalCount = action.payload.totalCount;
            state.error = null;
        },
        debtOrderFetched: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.debtOrderForEdit = action.payload.debtOrderForEdit;
            state.error = null;
        },
    }
})